import React from "react";
import { _ } from "../utils/i18n";

import RoundIconButton from "../components/round-icon-button";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import PhoneIcon from "@material-ui/icons/Phone";

const HurtigNav = () => {
  return (
    <div>
      {" "}
      <div
        className="hurtignav"
        id="hurtignav"
        style={{ flexDirection: "column" }}
      >
        <h3 className="hurtig-title">{_("Hurtignavigering")}</h3>
      </div>
      <RoundIconButton
        icon={<ArrowForwardIosIcon />}
        link={_("/case/")}
        linkLabel={_("Se våre case")}
      />
      <RoundIconButton
        icon={<PhoneIcon />}
        link={_("/kontakt/")}
        linkLabel={_("Ta kontakt med oss")}
      />
    </div>
  );
};

HurtigNav.propTypes = {};

HurtigNav.defaultProps = {};

export default HurtigNav;
